import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=25c0e07a&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchResults.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=25c0e07a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0e07a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c0e07a')) {
      api.createRecord('25c0e07a', component.options)
    } else {
      api.reload('25c0e07a', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=25c0e07a&scoped=true&", function () {
      api.rerender('25c0e07a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SearchBar/components/SearchResults.vue"
export default component.exports